<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @openEditFormDialog="openEditFormDialog"
      @reload="reload"
      @batchDel="submitDel"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      v-if="goodsProofingDialogParams.visible"
      show-close
      visible
      width="1000px"
      top="10vh"
      :title="goodsProofingDialogParams.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <goodsProofingDialog
        ref="editForm"
        v-if="goodsProofingDialogParams.visible"
        :changeOrderCode="changeOrderCode"
        :disabled="goodsProofingDialogParams.disabled"
        :code="goodsProofingDialogParams.code"
        :isCopy="goodsProofingDialogParams.isCopy"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!goodsProofingDialogParams.disabled"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import GoodsProofingDialog from '../edit-form'

export default {
  components: {
    PageHeader,
    PageMain,
    GoodsProofingDialog,
  },
  mixins: [BaseTable],
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      goodsProofingDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  mounted() {},
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .changeOrderProofingListApi({
          changeOrderCode: this.changeOrderCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.changeOrderGoodsProofingDelApi({ listCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$refs.tableHeader.query()
        })
      })
    },
    closeEditFormDialog() {
      this.goodsProofingDialogParams.visible = false
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        add: this.$l('INDEX.dialog_title_order_proofing_add') || '添加样品要求信息',
        edit: this.$l('INDEX.dialog_title_order_proofing_edit') || '编辑样品要求信息',
        detail:
          this.$l('INDEX.dialog_title_order_proofing_view') || '样品要求信息详情',
        copy: this.$l('dialog_title_order_proofing_copy') || '复制样品要求信息',
      }
      this.goodsProofingDialogParams = {
        visible: true,
        title: types[type],
        code: params.code,
        disabled: type === 'detail',
        isCopy: type === 'copy',
      }
    },
  },
}
</script>
